/*
 * Represents a collection of common text used in the application.
 */
export const Vocabulary: any = {
  /** COMMON TEXT */
  login: "Conectare",
  loginValidationError: "Eroare la validarea datelor!",
  requiredField: "Acest câmp este obligatoriu.",
  emailValidation: "Introduceți  o adresă valida.",
  pageNotFound: "Pagina nu a fost găsită!",
  search: "Căutare",
  siteName: "SigurLaVolan",
  delay: "Întârziere",
  logout: "Deconectare",
  documentation: "Documentație",
  defaultManagement: "Gestiune implicită",
  subtotal: "Subtotal",
  confirm: "Confirmare",
  orderOfferWhatsappTemplate: "Șablon WhatsApp pentru comandă/ofertă",
  whatsAppFooterNoteObservation: "",
  pages: "Pagini",
  image: "Imagine",
  newMasculine: "Nou",
  userManual: "Manual de utilizare",
  notifications: "Notificări",
  noNotifications: "Nu există notificări",
  myAccount: "Contul meu",
  legalPerson: "Persoană juridică",
  physicalPerson: "Persoană fizică",
  shouldClientReceiveEmail: "Clientul ar trebui să fie contactat prin email?",
  syncProducts: "Sincronizare produse",
  users: "Utilizatori",
  user: "Utilizator",
  CNP: "CNP",
  userSettings: "Setări utilizator",
  noConversationsAvailable: "Nu sunt conversații disponibile",
  addNewConversation: "Adaugă conversație nouă",
  conversations: "Conversații WhatsApp",
  newConversation: "Conversație nouă",
  selectAllProductsForInvoice: "Selectează toate produsele pentru facturare",
  selectAtLeastOneAnswer: "Selectați cel puțin un răspuns!",
  departments: "Departamente",
  options: "Opțiuni",
  WARNING: "Avertisment",
  phoneNumbers: "Numere de telefon",
  availablePhoneNumber: "Număr de telefon disponibil",
  whatsAppEditTemplateLimit:
    " Șabloanele aprobate pot fi editate de până la 10 ori într-o fereastră de 30 de zile sau o dată într-o fereastră de 24 de ore. Dacă ați efectuat deja această acțiune, vă rugăm să reveniți mai târziu.",
  whatsAppTemplateEditingWarning:
    "Doar șabloanele cu statusul APROBAT, RESPINS sau ÎN APROBARE pot fi editate. Puteți edita doar categoria sau componentele unui șablon. Nu puteți edita categoria unui șablon aprobat. Șabloanele aprobate pot fi editate de până la 10 ori într-o fereastră de 30 de zile sau o dată într-o fereastră de 24 de ore. Șabloanele respinse sau în pauză pot fi editate de un număr nelimitat de ori. După editarea unui șablon aprobat sau în aprobare, acesta va fi aprobat automat, cu excepția cazului în care nu trece de revizuirea șablonului.",
  countryCode: "Cod țară",
  phoneNumbersDisplayName: "Numele afișat pentru numărul de telefon",
  lastName: "Nume",
  product: "Produs",
  entityName: "Nume entitate",
  collected: "Încasată",
  collect: "Încasează",
  notCollected: "Neîncasată",
  canceled: "Anulată",
  corrected: "Stornată",
  invoiced: "Facturat",
  previewDocument: "Previzualizare document",
  previewVideo: "Previzualizare video",
  addPhoneNumber: "Adaugă număr de telefon",
  firstName: "Prenume",
  preview: "Previzualizare",
  continue: "Continuă",
  code: "Cod",
  property: "Proprietate",
  create: "Crează",
  upload: "Încarcă",
  learnMore: "Află mai mult",
  pin: "PIN",
  select: "Selectați",
  back: "Înapoi",
  phoneNumbersDisplayNameHelperText:
    "Numele dvs. afișat trebuie să se potrivească cu numele companiei dvs. și să respecte regulile privind numele afișat WhatsApp Business. ",
  twoStepVerificationPinHelperText:
    "Introduceți un cod pentru autentificarea în doi pași atunci când vă conectați utilizând numărul de telefon WhatsApp Business",
  lastStep: "Ultimul pas",
  registerPhoneNumber: "Înregistrare număr de telefon",
  register: "Înregistrare",
  dontHaveAccount: "Nu ai cont? Creează-ți unul",
  verifyPhoneNumberRegistrationCode:
    "Introducere cod de verificare primit prin SMS",
  setPinForTwoStepVerification: "Setare PIN pentru autentificare în doi pași",
  buttonText: "Text buton",
  orderNr: "Număr comandă",
  thankYouForYourOrder: "Mulțumim! Comanda a fost plasată.",
  ANPC: "ANPC",
  contact: "Contact",
  addNewTemplate: "Adaugă șablon nou",
  cookiePolicy: "Politica Cookies",
  old: "Veche",
  goods: "Marfa",
  password: "Parolă",
  newPassword: "Parolă nouă",
  confirmPassword: "Confirmă parolă",
  resetPassword: "Resetare parolă",
  forgotPassword: "Ai uitat parola?",
  passwordsDoNotMatch: "Parolele nu se potrivesc",
  view: "Vizualizează",
  cancelAction: "Anulează",
  billingAction: "Facturează",
  previous: "Anterior",
  next: "Următor",
  crtNo: "Nr. crt.",
  invoice: "Factură",
  notice: "Aviz",
  issuingInvoice: "Emitere factură",
  issuingNotice: "Emitere aviz",
  email: "Email",
  addImage: "Adaugă imagine",
  columns: "Coloane",
  phoneNumber: "Număr de telefon",
  roles: "Roluri",
  role: "Rol",
  lei: "Lei",
  department: "Departament",
  edit: "Editează",
  delete: "Șterge",
  description: "Descriere",
  noResultsFound: "Nu a fost găsit nici un rezultat...",
  noResponseGot: "Nu a fost primit răspuns...",
  nextPage: "Pagina următoare",
  previousPage: "Pagina anterioară",
  rowsPerPage: "Rânduri pe pagină",
  of: "din",
  downloadCSV: "Descarcă CSV",
  print: "Printează",
  uploadImageOnEmailTemplateMessage:
    "Asigurați-vă că ați plasat cursorul unde doriți să plasați imaginea!",
  rowsDeleted: "rânduri șterse",
  rowsSelected: "rânduri selectate",
  usersList: "Listă utilizatori",
  departmentsList: "Listă departamente",
  tasksList: "Listă task-uri",
  projectsList: "Listă proiecte",
  reportsList: "Listă rapoarte",
  deleteFilters: "Șterge filtre",
  tasks: "Task-uri",
  add: "Adaugă",
  import: "Importă",
  project: "Proiect",
  assignedUser: "Responsabil",
  name: "Nume",
  ok: "OK",
  addSubtask: "Adaugă subtask",
  subtask: "Subtask",
  subtasks: "Subtask-uri",
  noUserAssigned: "Nu există utilizator asignat",
  sendMessageTemplateToUser: "Trimite șablon",
  selectAConversation: "Selectează o conversație.",
  canOnlySendTemplateToClient:
    "Șabloanele pot fi trimise doar clienților existenți.",
  youHaveUnreadMessages: "Aveți mesaje necitite.",
  markAllAsRead: "Marchează toate ca citite",
  unsavedChangesTitleModal: "Modificări nesalvate",
  unsavedChangesTextModal:
    "Dacă părăsiți pagina, modificările nesalvate vor fi pierdute. Sunteți sigur că doriți să părăsiți pagina?",
  departmentHead: "Șef departament",
  projectManager: "Manager proiect",
  status: "Status",
  flexibleTask: "Task flexibil",
  repeatsOn: "Repetă",
  skipWeekend: "Sari peste weekend",
  flexibleTaskObservations:
    "Permite posibilitatea de modificare a periodicitații",
  progress: "Progres",
  addNewUser: "Adaugă utilizator nou",
  editUser: "Editează utilizator",
  addNewDepartment: "Adaugă departament nou",
  save: "Salvare",
  approve: "Aprobare",
  approved: "Aprobat",
  saveContact: "Salvează contact",
  cancel: "Anulare",
  addFiles: "Adaugă fișiere",
  finish: "Finalizare",
  generate: "Generează",
  finished: "Finalizat",
  unfinished: "Nefinalizat",
  userName: "Nume utilizator",
  taskName: "Nume task",
  active: "Active",
  addConversation: "Adaugă conversație",
  archived: "Arhivat",
  cif: "CIF",
  messages: "Mesagerie WhatsApp",
  baseInfo: "Informații generale",
  dynamicInfo: "Informații dinamice",
  attachments: "Atașamente",
  issueDate: "Data emiterii",
  dueDate: "Data scadenței",
  otherInfos: "Alte informații",
  issuerName: "Întocmit de",
  issuerId: "CNP",
  deputyIdentityCard: "Carte identitate delegat",
  selesAgent: "Agent vânzări",
  filters: "Filtre",
  invoiceWarning:
    "Pentru a evita erori și neînțelegeri în procesul de facturare, vă rugăm să verificați cu atenție informațiile despre client înainte de a emite o factură. Asigurați-vă că toate datele sunt corecte și actualizate pentru a asigura un proces de facturare fără probleme. ",
  deputyName: "Delegat",
  fancyName: "Denumire",
  startDate: "Data",
  nextContactDate: "Data următoarei contactări",
  nextTransportDate: "Data următoarei livrări",
  endDate: "Data final",
  fullName: "Nume complet",
  position: "Funcție",
  dragAndDrop:
    "Trageți și plasați orice fișier aici sau răsfoiți de pe dispozitiv",
  error: "Eroare!",
  notFound: "Nu a fost găsit.",
  dashboard: "Dashboard",
  statistics: "Statistici",
  statisticsDashboard: "Dashboard statistici",
  statisticsExam: "Statistici mode examinare",
  statisticsLeaning: "Statistici mode învățare",
  noStatisticsAvailable: "Nu există statistici disponibile",
  url: "URL",
  supportTickets: "Tichete suport",
  marketing: "Marketing",
  sales: "Vânzări",
  profilePicture: "Poza de profil",
  addCustomField: "Adaugă câmp personalizat",
  customField: "Câmp personalizat",
  custom: "Personalizat",
  specificAction: "Acțiune specifică",
  quickReply: "Răspuns rapid",
  visitSite: "Vizitează site",
  callPhoneNumber: "Sună numărul de telefon",
  value: "Valoare",
  priority: "Prioritate",
  periodicity: "Periodicitate",
  periodic: "Periodic",
  type: "Tip",
  home: "Acasă",
  daily: "Zilnic",
  weekly: "Săptămânal",
  monthly: "Lunar",
  yearly: "Anual",
  choosePeriodicity: "Alege periodicitate",
  biannual: "Semestrial",
  quarterly: "Trimestrial",
  unique: "Unic",
  highPriority: "Înaltă",
  mediumPriority: "Medie",
  lowPriority: "Scăzută",
  chooseUser: "Alege utilizator",
  chooseProject: "Alege proiect",
  choosePriority: "Alege prioritate",
  chooseDepartment: "Alege departament",
  chooseStatus: "Alege status",
  clients: "Clienti",
  client: "Client",
  clientAccount: "Contul meu",
  scheduledExams: "Examene programate",
  manageExams: "Gestionează examenele tale teoretice și practice programate",
  noExamsScheduled: "Nu ai examene programate",
  noExamsText: "Nu ai niciun examen programat în acest moment.",
  certificateExams: "Examen Teoretic",
  certificateExamTitle: "Calendar de examinare teoretică",
  availableExams: "Examene disponibile",
  enrollInExam: "Înscrie-te la examen",
  examEnrollment: "Înscrierea la examen",
  daysMinimum: "zile minim",
  alreadyEnrolledMessage: "Ești înscris la acest examen",
  selectExamDate: "Selectează data examenului",
  addNewExam: "Adaugă examen nou",
  selectExamTypeAndDate: "Selectează tipul și data examenului",
  enrolled: "Inscris",
  examCalendar: "Calendar examene",
  noExamsAvailable: "Nu sunt examene disponibile în această lună",
  certificateExamCaption:
    "Selectează din calendar data la care dorești obținerea atestatelor/certificatelor de pregătire profesională.",
  enrollmentNote:
    "Înscrierea este disponibilă doar pentru datele afișate în calendar.",
  enrollmentDaysNotice:
    "Înscrierea la examen trebuie făcută cu cel puțin 5 zile înainte de data examenului.",
  documentInformation: "Informații despre documente",
  workpointInformation: "Informații despre sediul de înscriere",
  expiresOn: "Expiră pe",
  expired: "Expirat",
  validUntil: "Valid până pe",
  missing: "Lipsește",
  teoretic: "Teoretic",
  practic: "Practic",
  clientAddress: "Adresa client",
  clientDetails: "Detalii client",
  orderDetails: "Detalii comandă",
  phoneNumberDetails: "Detalii număr de telefon",
  order: "Comanda",
  Verified: "Verificat",
  notVerified: "Neverificat",
  postcode: "Cod poștal",
  creationDate: "Data creării",
  lastModified: "Ultima salvare",
  orderProducts: "Produse comandă",
  ordersStatuses: "Status comenzi",
  templates: "Șabloane",

  checkPhoneNumber: "Verificare număr de telefon",
  pagination: {
    next: "Urmator",
    previous: "Anterior",
    rowsPerPage: "Pe pagina:",
    displayRows: "din",
  },
  noData: "Nu exista date!",
  orders: "Comenzi",
  reset: "Resetează",
  resetInProgress:
    "Dacă emailul introdus este corect, veți primi un link pentru a reseta parolă.",
  statusesOrder: "Ordinea statusurilor",
  reports: "Rapoarte",
  confirmDeleteTitle: "Confirmare ștergere",
  confirmDeleteMessage:
    "Vrei să anulezi această oră de conducere? După confirmare, ora va fi ștearsă din programul tău și va trebui să alegi o altă dată.",

  confirmDuplicateMessage:
    "Ești sigur că vrei să duplici această înregistrare?",
  no: "Nu",
  yes: "Da",
  editModalTitle: "Editează",
  changePasswordTitle: "Introduce-ți o nouă parolă",
  username: "Nume utilizator",
  saveSuccess: "Datele au fost salvate cu succes!",
  saveError: "Eroare la salvarea datelor!",
  editOrderStatus: "Editează status comandă",
  addOrderStatus: "Adaugă status comandă",
  getError: "Eroare la preluarea datelor!",
  deleteSuccess: "Datele au fost șterse cu succes!",
  deleteError: "Eroare la ștergerea datelor!",
  newOrderStatus: "Status comandă nou",
  orderStatus: "Status comandă",
  phone: "Telefon",
  contactPerson: "Persoană de contact",
  address: "Adresă",
  usefulInfo: "Informații utile",
  observations: "Observații",
  noMoreMessages: "Nu mai sunt mesaje",
  sendMessagesInfo:
    "Pentru a comunica eficient prin WhatsApp, este necesar să trimitem mai întâi un template de mesaj aprobat de WhatsApp. Acest mesaj introductiv trebuie să ofere utilizatorului toate detaliile necesare și să solicite un răspuns. După ce utilizatorul răspunde la acest mesaj, putem continua conversația fără restricții, conform regulilor WhatsApp, asigurând astfel o comunicare fluentă și eficientă.",
  fiscalCode: "Cod fiscal",
  tradeRegisterNo: "Nr. Registru Comerț",
  registered: "Înregistrat",
  notRegistered: "Neînregistrat",
  whatsAppRegisterPhoneNumberHelperText:
    "Ultimul pas înainte de a putea comunica prin WhatsApp Business este să înregistrați numărul de telefon. Dacă numărul de telefon verificat are deja activată verificarea în doi pași, introduceți codul PIN de 6 cifre. Dacă numărul de telefon verificat nu are activată verificarea în doi pași, setați un cod PIN de 6 cifre. ",
  details: "Detalii",
  week: "Săptămâna",
  day: "Ziua",
  city: "Oraș",
  county: "Județ",
  tools: "Instrumente",
  country: "Țară",
  takenBy: "Preluat de",
  addressDetails: "Detalii adresă",
  category: "Categorie",
  categories: "Categorii",
  tags: "Etichete",
  addVariable: "Adaugă variabilă",
  selectATemplateBeforeSendingAnEmail:
    "Selectați un șablon înainte de a trimite un email",
  variable: "Variabilă",
  samplesForBodyContent: "Exemple pentru conținutul variabilelor",
  addButton: "Adaugă buton",
  whatsAppHeaderNoteObservation:
    "Adăugați un titlu sau alegeți ce tip de conținut media veți folosi pentru acest antet.",
  messageswhatsAppFooterNoteObservation:
    "Dacă adăugați mai mult de 3 butoane, acestea vor apărea într-o listă. Numărul maxim de butoane permise este 10.",
  enterWhatsAppMessageFooterText:
    "Adăugați un scurt text în subsolul șablonului de mesaj.",
  enterWhatsAppMessageBodyText:
    "Introduceți textul corpului mesajului WhatsApp în limba selectată.",
  whatsAppFooterButtonsHelperText:
    "Creați butoane care le permit clienților să răspundă la mesajul dumneavoastră sau să execute o acțiune specifică.",
  bank: "Banca",
  iban: "IBAN",
  noDays: "Nr. zile",
  optional: "Opțional",
  required: "Obligatoriu",
  contactPersonName: "Nume persoană contact",
  contactPersonPhoneNumber: "Număr de telefon persoană contact",
  contactPersonEmail: "Email persoană contact",
  categoryName: "Denumire categorie",
  periodicityName: "Nume periodicitate",
  color: "Culoare",
  chooseTemplate: "Alege șablon",
  chooseType: "Alege tip",
  emailContent: "Conținut email",
  exampleContent: "Exemplu conținut",
  price: "Preț",
  products: "Produse",
  actionSummary: "Sumar acțiune",
  emailContentError: "Conținutul email-ului este obligatoriu",
  pretOnSite: "Preț pe site",
  oblioPrice: "Preț Oblio",
  wordpressSync: "Sincronizare Wordpress",
  billing: "Facturare",
  diferences: "Diferențe",
  SUCCESS: "Succes",
  ERROR: "Eroare",
  errorWhileProcessingWronging: "Eroare la procesarea imaginii. Vă rugăm să încadrați actul cât mai corect posibil.",

  INFO: "Informație",
  action: "Acțiune",
  info: "Informație",
  noIdentifier: "Fără identificator",
  identifier: "Identificator",
  initialsValues: "Valori inițiale",
  modifiedValues: "Valori după modificare",
  "email-templates": "Șabloane email",
  "order-statuses": "Status comenzi",
  "transport-options": "Opțiuni transport",
  "tax-classes": "Clase TVA",
  "client-categories": "Categorii clienți",
  whatsapps: "Configurare WhatsApp",
  company: "Companie",
  ignoreOblioIdsList: "Lista de ID-uri Oblio ignorate (separate prin virgulă)",
  nameContactPerson: "Nume persoană contact",
  orderSummary: "Sumar comandă:",
  contactPhoneNumber: "Număr de contact",
  date: "Data",
  dateWithDiacritics: "Dată",
  total: "Total",
  logs: "Loguri",
  confirmSaveOrUpdateOrder: "Confirmați salvarea sau actualizarea comenzii?",
  orderSettings: "Setări comandă",
  startOrderNumber: "Nr. comandă start",
  currentOrderNumber: "Nr. comandă curent",
  paymentMethods: "Metode de plată",
  emailTemplates: "Șabloane email",
  emailPreview: "Previzualizare email",
  addClient: "Adaugă client nou",
  associateConversationWithClient: "Asociază conversația",
  associateExistingClient: "Asociază client existent",
  addNewClientOrAssociateExisting:
    "Momentan, conversația nu este asociată cu niciun client din aplicație. Dorești să adaugi un client nou, care va fi asociat automat cu această conversație, sau să asociezi unul existent?",
  template: "Șablon",
  subject: "Subiect",
  from: "De la",
  method: "Metodă",
  phoneNumberFormat: "(Format acceptat +40XXXXXXXXX)",
  nrOfAcceptedButtons: "Nr. butoane permise: ",
  whatsappIntegration: "Integrare WhatsApp",
  clientType: "Tip client",
  to: "Către",
  emailTemplate: "Șablon email",
  editor: "Editor",
  emailTemplateName: "Nume șablon email",
  associateClientWithConversation: "Asociază client cu conversație",
  cc: "CC",
  header: "Antet",
  body: "Corp",
  footer: "Subsol",
  buttons: "Butoane",
  productDescription: "Descriere produs",
  loginWithFacebook: "Conectare cu Facebook",
  dimensions: "Dimensiuni",
  length: "Lungime",
  templateName: "Nume șablon",
  templateLanguage: "Limba șablon",
  width: "Lățime",
  remarks: "Observații",
  enterTextInSelectedLanguage: "Introduceți text în limba selectată",
  whatsAppMessagesTemplates: "Șabloane mesaje WhatsApp",
  whatsAppTemplate: "Șablon WhatsApp",
  height: "Înălțime",
  start: "Start",
  end: "Sfârșit",
  days: "Zile",
  lateTask: "Task întârziat",
  finishDate: "Data finalizării",
  productLink: "Link produs",
  whatsAppTemplateBodyContentForHelperText:
    "Pentru a ne ajuta să revizuim șablonul dvs. de mesaj, vă rugăm să adăugați un exemplu pentru fiecare variabilă din corpul dvs. de text. Nu utilizați informații reale despre clienți",
  enterContentFor: "Introduceți conținut pentru",
  enterEmailAddressesSeparatedByComma:
    "Introduceți adresele de e-mail separate prin virgulă",
  addDynamicData: "Adaugă date dinamice",
  additionalData: "Date suplimentare",
  emailTemplateAttachedToOrderStatus: "Atașează la statusul comenzii",
  productName: "Nume Produs",
  unitMeasure: "Unitate de masură",
  quantity: "Cantitate",
  unitPrice: "Preț unitar fără tva",
  cotaTVA: "Cota TVA",
  tva: "TVA",
  duplicate: "Duplică",
  youNeedToSelectAtLeastOneProductToGenerateInvoice:
    "Trebuie să selectați cel puțin un produs pentru a genera o factură",
  youNeedToSelectAtLeastOneProductToGenerateNotice:
    "Trebuie să selectați cel puțin un produs pentru a genera un aviz",
  nr: "Nr.",
  discount: "Discount",
  totalDiscount: "Total discount",
  totalDiscountWithouTVA: "Total discount fără TVA",
  totalWithoutTVA: "Total fără TVA",
  otherCosts: "Alte costuri",
  addProducts: "Adaugă produs",
  collectDocType: "Tip document încasare",
  subTotal: "Sub-total",
  valueWithoutTVA: "Valoare fără TVA",
  priveWithTVA: "Preț unitar cu TVA",
  priceWithoutTVA: "Preț fără TVA",
  shippingInfo: "Informații transport",
  sameAsBilling: "Adresa din datele de facturare",
  newShipping: "Adresa de livrare noua",
  cash: "Numerar la livrare",
  delivery: "Livrare",
  backTransfer: "Transfer bancar",
  orderHasntBeenGenerated: "Comanda nu a fost generata",
  card: "Card online",
  vatRate: "Cota TVA",
  subtotalWithTVA: "Subtotal cu TVA",
  subtotal_tax: "Valoare",
  clientContactedOverEmail: "Contactat prin email:",
  clientCalled: "Contactat telefonic:",
  clientMessaged: "Contactat prin mesaj:",
  takeCustomer: "Preia client",
  totalWithTVA: "Total cu TVA",
  totalTVAIncluded: "Total TVA inclus",
  showTVA: "Afișeaza TVA",
  service: "Serviciu",
  never: "Niciodată",
  courierShipping: "Transport curier",
  stock: "Stoc",
  newOrder: "Comandă nouă",
  close: "Închide",
  noTodaysClients: "Clienți de contactat astăzi",
  clientsToContact: "Clienți de contactat",
  clientsContacted: "Clienți  contactati",
  availableClients: "Clienți zilnici disponibili",
  takenClients: "Clienți zilnici preluati",
  delayedClients: "Clienți disponibili (întârziați)",
  new: "Nouă",
  cifIsRequired: "CIF-ul este obligatoriu",
  clientNameIsRequired: "Numele clientului este obligatoriu",
  seriesNameIsRequired: "Numele seriei este obligatoriu",
  productNameIsRequired: "Numele produsului este obligatoriu",
  productPriceIsRequired: "Prețul produsului este obligatoriu",
  productQuantityIsRequired: "Cantitatea produsului este obligatorie",
  issuerNameIsRequired: "Numele emitentului este obligatoriu",
  issuerIdIsRequired: "CNP-ul emitentului este obligatoriu",
  mentions: "Mentiuni",
  noticeNumber: "Nr. aviz însoțire",
  defaultInvoiceMentions:
    "Factura valabila fără semnatura si ătampila cf. art. V, ALIN(2) DIN ORD. NR. 17/2015 SI ART. 319 ALIN.(29) DIN LEGEA NR. 227/2015 PRIVIND CODUL FISCAL .Cumparatorul isi exprima acordul privind prelucrarea datelor cu caracter personal, comunicate, date ce vor fi utilizate in scopul intocmirii documentelor comerciale de facturare, incasare, expediere si ofertarii comerciale. Orice modificare de preț va fi afisata pe site-ul www.ECOPACKBUSINESS.ro",
  invoicesInfo: "Informații facturare",
  discountValue: "Valoare discount",
  shortDescription: "Descriere scurta",
  unitTVA: "Valoare unitara TVA",
  confirmDelete: "Confirma stergerea",
  settings: "Setari",
  managements: "Gestiuni",
  management: "Gestiune",
  otherSettings: "Alte setari",
  saveWhatsAppSettings: "Salvează setările WhatsApp",
  shippingSettings: "Setări transport",
  whatsAppBusinessAccountId: "Id cont WhatsApp Business",
  whatsAppBusinessAccountName: "Nume cont  WhatsApp Business",
  whatsAppBusinessPhoneNumberId: "Id număr de telefon WhatsApp Business",
  whatsAppBusinessVerifiedName: "Nume WhatsApp Business",
  whatsAppBusinessAccountDataUpdateMessage:
    "Sunteți sigur că doriți să actualizați datele contului WhatsApp Business?",
  oblio: "Oblio",
  conversationOptions: "Opțiuni conversație",
  LOCAL: "Local",
  WORDPRESS: "WordPress",
  OBLIO: "Oblio",
  META: "META",
  whatsApp: "WhatsApp",
  contactDate: "Data contactării",
  shipping: "Transport",
  clientCategory: "Categorie client",
  clientNotesHistory: "Istoric note client",
  welcomeBack: "Bine ai revenit,",
  sendMessage: "Trimite mesaj",
  sendEmail: "Trimite email",
  createOrder: "Creează comandă",
  summary: "Sumar",
  visibleToClient: "Vizibil clientului",
  finishContact: "Finalizează contact",
  contactedOnPhone: "Telefonic",
  clientCategories: "Categorii clienti",
  wasClientCalledOverPhone: "Clientul a fost contactat telefonic?",
  contacted: "Contactat",
  noOrder: "Fără comandă",
  notContacted: "Necontactat",
  shouldSendEmailToAllClients:
    "Activează/dezactivează trimiterea automată de emailuri pentru toți clienții.",
  addNotes: "Adaugă note",
  text: "Text",
  reply: "Răspunde",
  templatePreview: "Previzualizare șablon",
  note: "Nota",
  doYouWantToTakeOverThisClient: "Doriți să preluați acest client?",
  transportName: "Nume transport",
  transportValue: "Valoare transport",
  isDefaultTransport: "Transport implicit",
  addMethod: "Adaugă metodă",
  paymentMethod: "Metodă de plată",
  loadMoreMessages: "Incarca mai multe mesaje",
  noPreviewAvailable: "Previzualizare indisponibilă",
  noMessagesYet:
    "Nu există mesaje.\n Pentru a iniția o conversație, trimiteți un sablon. \n\n Dacă clientul va raspunde în 24 de ore veți putea trimite mesaje nelimitate.",
  romania: "România",
  send: "Trimite",
  document: "Document",
  addCaption: "Adaugă descriere",
  missingFile: "Fișier lipsă",
  chooseColor: "Alege culoare",
  orderConfirmMessage: "Vă mulțumim pentru comanda dumneavoastră!",
  chooseNextContactDate: "Alege data urmatoarei contactări:",
  loading: "Se încarca...",
  noMoreItems: "Nu mai sunt elemente!",
  shippingCost: "Cost transport (TVA inclus)",
  currency: "LEI",
  unsavedMessage: "Ai modificari nesalvate!",
  clientConversation: "Conversatie client",
  database: "Baza de date",
  transportMethods: "Metode transport",
  confirmMessage: "Parolele nu coincid!",
  phoneValidation: "Numarul de telefon este invalid",
  finishOrder: "Finalizare comanda",
  clientNote: "Nota adăugată de client",
  optionalOrderNote: "Note comandă (opțional)",
  invalidEmail: "Email invalid",
  deleteAccount: "Șterge contul",
  deleteAccountConfirm: "Ești sigur că vrei să ștergi contul? Această acțiune este ireversibilă.",
  deleteAccountSuccess: "Contul a fost șters cu succes.",
  invalidCNPLength: "CNP invalid. Trebuie să conțină 13 cifre.",
  invalidCNP: "CNP invalid.",
  contacts: "Contacte",
  threshold: "Valoare de prag (limită)",
  rule: "Regulă",
  agent: "Agent",
  sendNotificationsTo: "Trimite notificări către",
  imagePreview: "Previzualizare imagine",
  contactDeletionThreshold:
    "Numărul de zile după care contactele vechi sunt șterse automat",
  data: "Data",
  shouldRenderOldContactsOnDashboard: "Afișează contactele vechi pe Dashboard.",
  orderMessage:
    "Pentru comenzile ce depasesc 5KG se taxeaza în plus 1 LEU / KG.",
  pressTocChangeStatus: "Apasă pentru a adaugă/schimbă statusul comenzii",
  invoiceDetails: "Detalii de facturare",
  anotherAddress: "Livrezi la o altă adresă?",
  yourOrder: "Comanda ta",
  addNewSubtask: "Adaugă subtask nou",
  imageAlternativeText: "Text alternativ imagine",
  deleteImages: "Șterge imagini",
  outOfStock: "Stoc epuizat",
  assignedBy: "Alocate de",
  editSubtask: "Editează subtask",
  attachedFiles: "Fișiere atașate",
  emptyFields: "Golește câmpurile",
  inStock: "În stoc",
  duplicateTask: "Duplică task",
  task: "Task",
  alerts: "Alerte",
  alert: "Alertă",
  onBackOrder: "Pe comandă",
  customFilter: "Filtru personalizat",
  table: "Tabel",
  noStockInfo: "Fără informații despre stoc",
  endOrder: "Plasează comanda",
  footerText:
    "Avem la comercializare o gama variata de pungi de hartie, atat albita, cat si natur, dar si sacose de hartie cu maner flat sau sfoara.",
  copyright: "© Sigur la volan Business 2025",
  imageUploadErrorMessage:
    "Trebuie să incărcați o imagine și să oferiți o alternativă de text pentru aceasta!",
  /**AUDIT ACTIONS */
  CREATE: "Adăugare",
  UPDATE: "Actualizare",
  DELETE: "Ștergere",
  SOFT_DELETE: "Inactivare",
  IMPORT: "Import",
  DUPLICATE: "Duplicare",
  /**ERRORS */
  systemError: "Eroare de sistem. Contactează administratorul!",
  getDataError: "Eroare la preluarea datelor!",
  deleteDataError: "Eroare la ștergerea datelor!",
  importDataError: "Eroare la importul datelor!",
  createDataError: "Eroare la adăugarea datelor!",
  updateDataError: "Eroare la actualizarea datelor!",
  deleteDataSuccess: "Datele au fost șterse cu succes!",
  importDataSuccess: "Datele au fost importate cu succes!",
  createDataSuccess: "Datele au fost adăugate cu succes!",
  updateDataSuccess: "Datele au fost actualizate cu succes!",
  chooseStatusColor: "Alegeți o culoare pentru status.",
  questionnaire: "Mediu de învățare",
  modParcurgereIntrebari:
    "Parcurge Capitolele și Pregătește-te Pentru Examen În Mod Interactiv",
  resetQuestionare: "Resetare întrebări pregătitoare",
  resetQuestionaryWarning:
    "Sigur doriți să reveniți la început și să ștergeți progresul întrebărilor din setul curent? Această acțiune nu poate fi anulată.",
  correct: "Corecte",
  incorrect: "Greșite",
  finishedTest: "Testul a fost finalizat!",
  correctAnswers: "Răspunsuri corecte",
  wrongAnswers: "Răspunsuri greșite",
  allQuestionsAnsweredMessage:
    "Poți revizui răspunsurile tale folosind rezumatul întrebărilor sau navigând prin întrebări.",
  questionsSummary: "Sumar întrebări",
  question: "Întrebarea",
  simulateExam: "Simulează examen",
  failedExamText:
    "Testul a luat sfârșit. Ați fost declarat RESPINS la examenul de teorie.",
  passedExamText:
    "Felicitări! Ați fost declarat PROMOVAT la examenul de teorie.",
  examStartAlert: "Bine ați venit la examenul auto!",
  examStartAlertText: "Doriți să începeți o nouă simulare a examenului auto?",
  liveLegislation: "Legislație Rutieră - LIVE",
  accessLive: "Accesează live-ul",
  accesLiveText:
    "Te invităm să urmărești sesiunea live de legislație, unde discutăm noțiuni esențiale pentru examenul auto.",
  liveInviteText:
    "Este o ocazie excelentă să înveți, să pui întrebări și să îți consolidezi cunoștințele.",
  noLiveScheduled:
    "Momentan nu avem nicio sesiune live programată, dar poți activa notificările ca să afli imediat când va fi următoarea.",
  liveLegislationSession: "Sesiune Live - Legislație Rutieră",
  exitMeeting: "Părăsește sesiunea",
  activateNotifications: "Activează notificările",
  commonWrongQuestions: "Întrebări greşite frecvent",
  commonWrongQuestionsExplanation:
    "Sunt întrebările la care ai greșit de câteva ori și la care mai ai nevoie de exersare. Le poți folosi ca să te pregătești mai bine și să fii sigur că vei reuși la examen!",
  practiceAllAgain: "Exersează-le pe toate din nou",
  practiceThisCategory: "Exersează această categorie",
  totalQuestionsLabel: "întrebări la examen",
  minutesLabel: "minute",
  maxWrongAllowed: "Greșeli permise",
  noWrongQuestionsYet: "Nu ai întrebări greșite frecvent deocamdată.",
  wrongQuestionSingular: "întrebare greșită",
  wrongQuestionPlural: "întrebări greșite",
  reportExplanation: "Raportează",
  reportTitle:
    "Ai observat ceva în neregulă cu această întrebare sau explicație? ",
  reportConfirmation:
    "Te rugăm să ne spui care este problema cu această întrebare sau cu explicația oferită. Vom analiza raportarea și vom lua măsurile necesare pentru a corecta eventualele greșeli.",
  reportDescriptionPlaceholder:
    "Ex: Întrebarea este formulată ambiguu, răspunsul corect este discutabil, explicația nu este clară etc..",
  examPassedSuccess: "Examene trecute cu succes",
  examFailed: "Examene picate",
  totalExams: "Total examene efectuate",
  passedExamPercentage: "Procent promovare",
  examStatistics: "STATISTICI MOD EXAMINARE",
  learningStatistics: "STATISTICI MOD ÎNVĂȚARE AUTO",
  examCategory: "Categorie auto",
  aiChat: "Asistentul tău virtual",
  chatWelcomeMessage: "Bună 👋, ai nevoie de ajutor?",
  typeYourMessage: "Introduceți mesajul tău...",
  investigating: "Se investighează...",
  online: "Online",
  unknownError: "Eroare necunoscuta",
  chatQuickOptions: "Alege o opțiune pentru a continua:",
  questions: "Întrebări examen",
  questionDescriptions: "Întrebări de legislație din cursul de pregătire auto",
  legalInfo: "Informații legislație rutieră",
  legalDescription: "Informații legale despre legislația rutieră",
  aboutCompany: "Despre companie",
  companyDescription: "Informații despre Sigur la Volan",
  aboutUser: "Informații despre utilizator",
  aboutUserDescription: "Informații despre utilizatorul dvs.",
  unExpectedErrorTryAgain: "Eroare neașteptată, încercați din nou",
  benefits: "Beneficii",
  benefitsText:
    "Instructor / mașină la alegere, asistență la întocmirea actelor pentru dosar, STUDENȚII pot fi școlarizați în Suceava sau Iași și pot susține examenele în județul de domiciliu fără costuri suplimentare.",
  certificateBenefitsText:
    "Asistență la întocmirea actelor pentru dosar și la eliberarea atestatelor. Posibilitate de examinare și pregătire în oricare din județele partenere fără costuri suplimentare.",
  includedInPrice:
    "În preț sunt incluse ore de conducere, cursuri de legislație rutieră nelimitate (chiar și online), programări direct de la sediul nostru pentru examenul teoretic și cel practic.",
  certificateIncludedInPrice:
    "În preț sunt incluse ședinte de conducere pe camioanele proprii (unde este cazul), cursuri teoretice nelimitate, chiar și online, manuale de pregătire simplificate, programare la examene direct de la sediu.",
  priceNotes:
    "Valoarea cursurilor poate fi plătită în rate. Prețurile sunt exprimate in lei si includ TVA, sunt negociabile, în funcție de pachetul ales, de numărul de categorii, atestate, fidelitate.",
  certificatePriceNotes:
    "Valoarea cursurilor poate fi plătită in rate, prețurile sunt exprimate în lei și sunt scutite de TVA. Acestea pot fi negociabile în funcție de pachetul ales, fidelitate și de numărul de servicii.",
  offerValid: "Ofertă valabilă de la 04.08.2025",

  // ID Scanning functionality
  fitYourImageInSquare:
    "Aliniați cartea de identitate românească în cadrul verde",
  imageProcessedSuccessfully: "Imaginea a fost prelucrată cu succes",
  imageProcessingFailed: "maginea nu a fost prelucrată cu succes, plaseasa imaginea în regim portret",
  scanIdCard: "Scanează buletinul",
  scan: "Scanează",
  selectIdCardImage: "Selectează imaginea buletinului",
  clickToSelectImage: "Apasă pentru a selecta o imagine",
  selectImage: "Selectează imagine",
  imageSelected: "Imagine selectată",
  changeImage: "Schimbă imaginea",
  scanNow: "Scanează acum",
  scanning: "Se scanează...",
  scanError: "Eroare la scanarea buletinului. Te rugăm să încerci din nou.",
  pleaseSelectFile: "Te rugăm să selectezi o imagine.",
  cameraPermissionDenied:
    "Permisiunea pentru cameră a fost refuzată. Te rugăm să permiți accesul la cameră în setările dispozitivului.",
  cameraNotFound:
    "Camera nu a fost găsită. Te rugăm să verifici dacă camera este conectată și funcțională.",
  takeAPhoto: "Captează o fotografie",
  changeCamera: "Rotește camera",
  photoTaken: "Fotografia a fost capturată",
  takePhoto: "Captură o fotografie",
  process: "Procesare",
  uploadPhoto: "Încarcă o poză",
  imageIsProcessing: "Se procesează...",
  pleaseWaitProcessingYourPhoto:
    "Vă rugăm să așteptați, procesăm fotografia...",
  registerStep1: "Alege Locația și Cursul",
  registerStep2: "Informațiile Tale",
  registerStep3: "Plata avans",
  subscriptionChooseStep: "Alege Plan",
  subscriptionChooseStepDescription:
    "Alege planul de abonament care se potrivește cel mai bine nevoilor tale",
  completeDataToFinishRegistration:
    "Te rugăm să completezi datele pentru a finaliza înregistrarea",
  personalInfoStepDescription:
    "Completează datele tale personale pentru a finaliza înregistrarea",
  agreeTermsAndConditions: "Sunt de acord cu Termenii și Condițiile",
  agreePrivacyPolicy: "Sunt de acord cu Politica de Confidențialitate",
  cnpHelperText: "Cod Numeric Personal",
  personalInfo: "Informații Personale",
  addressInfo: "Informații Adresă",
  processingFailed: "Procesarea a eșuat",
  advance: "Avans",
  Permis: "Scoala de șoferi",
  Atestat: "Atestate",
  noDatasetsAvailable:
    "Nu există seturi de date disponibile poti să incerci din nou",

  // Payment Summary
  finalizeOrder: "Finalizare comandă",
  orderSummaryTitle: "Sumar comandă",
  clientInformation: "Informații client",
  selectedCourse: "Curs selectat",
  serviceType: "Tip serviciu",
  course: "Curs",
  courses: "Cursuri",
  totalAmount: "Total",
  paymentRedirect: "Redirecționare către plată",
  paymentRedirectMessage:
    "Vei fi redirecționat automat către pagina de plată securizată în câteva secunde...",

  // Order Status Page
  orderStatusPage: "Status Plată",
  orderIdMissing: "ID comandă sau status lipsă",
  orderStatusLoadError: "Eroare la încărcarea statusului comenzii",
  transactionSuccess:
    "Tranzacție realizată cu succes, un consultant te va contacta în 24 ore.",
  transactionRejected:
    "Tranzacție refuzată. Te rugăm să încerci din nou sau să ne contactezi pentru asistență.",
  orderCanceled: "Comanda a fost anulată.",
  orderPending:
    "Comanda ta este în curs de procesare. Vei fi contactat în curând.",
  orderProcessing: "Procesăm comanda ta. Te rugăm să aștepți confirmarea.",
  unknownOrderStatus:
    "Status comandă necunoscut. Te rugăm să ne contactezi pentru detalii.",

  // Payment Status Modal
  paymentStatus: "Status de plată",
  checkingPaymentStatus: "Verificăm statusul plății...",
  paymentStatusCheckError: "Eroare la verificarea statusului plății.",
  paymentFailedMessage:
    "Plata nu a fost finalizată cu succes. Vă rugăm încercați din nou.",
  bonus: "Bonus",
  supplementaryHours: "Ore suplimentare",

  supportContactInfo:
    "Pentru întrebări sau asistență, te rugăm să ne contactezi la:",
  supportEmail: "office@sigurlavolan.ro",
  consultantContactMessage:
    "Vă mulțumim pentru plata efectuată și pentru interesul acordat școlii noastre de conducere. Un consultant vă va contacta în cel mult 24 de ore pentru a vă oferi toate detaliile necesare privind următorii pași.",
  allowBrowserNotifications: "Permiteți notificările browserului?",
  notificationDescription:
    "Primiți notificări în timp real pentru mesaje noi, actualizări importante și alte evenimente relevante.",
  block: "Blochează",
  allow: "Permite",
  newMessage: "Mesaj nou!",
  selectDateToViewExams:
    "Selectează o dată pentru a vedea examenele programate",
  noExamsAvailableForThisDay: "Nu sunt examene disponibile pentru această zi.",
  upcomingExamTimeNotice:
    "Ora exactă a examenului va fi comunicată cu câteva zile înainte de susținere.",
  confirmRegistrationMessage:
    "Ești sigur că vrei să te înscrii la examenul teoretic?",
  confirmRegistrationNotice:
    "După confirmare, vei fi adăugat pe lista de participanți și nu vei mai putea anula înscrierea.",
  loginCredentialsSentMessage:
    "Datele dumneavoastră de conectare v-au fost trimise pe email. Apăsați butonul pentru a intra în cont.",
  enterAccount: "Intră în cont",
  drivingSessionScheduling: "Sedinta de conducere",
  selectAvailableSlotInfo:
    "Selectați un slot disponibil pentru a programa o ședință de conducere.",
  waitingInstructorApproval: "În aprobare",
  available: "Disponibil",
  booked: "Rezervat",
  instructor: "Instructor",
  alreadyBookedForDay:
    "Ai deja o rezervare pentru această zi. Poți rezerva doar un interval pe zi.",
  chooseExamSimulation:
    "Alege categoria de permis pentru care vrei să te pregătești!",
  chooseExamCategory:
    "Selectează categoria pentru care dorești să simulezi examenul",
  multipleCategoriesNotice:
    "Deoarece ai achitat cursuri pentru mai multe categorii, poți simula examenul pentru fiecare dintre ele",
  startExamSimulation: "Începe simularea",
  includedHours: "Ore incluse",
  bookedHours: "Ore rezervate",
  remainingHours: "Ore rămase",
  used: "utilizat",
  noMoreHoursAvailable: "Nu mai ai ore disponibile.",
  pleaseContactToPurchaseSupplementaryHours:
    "Te rugăm să ne contactezi pentru a achiziționa ore suplimentare.",
  noHoursRemainingForBooking:
    "Nu poți rezerva această oră deoarece nu mai ai ore disponibile în pachet.",
  allHoursCompletedForService:
    "Pentru serviciul {productName} ai parcurs toate orele incluse. Poți adăuga ore suplimentare direct din aplicație și continua pregătirea! 🚗💪",
  minPaymentRequiredForDrivingLessons:
    "Pentru a programa ore de conducere, trebuie să achitați minimum {amount} lei. Vă rugăm să efectuați plata pentru a continua.",
  registrationDescription:
    "Îți oferim instrumentele necesare pentru a învăța corect și a trece examenul cu încredere.",
  registrationTitle: "Alege abonamentul potrivit pentru tine",
  finishAndPay: "Finalizează și plătește",
  isProcessing: "Se procesează...",
  selectPlanToContinue: "Te rog selectează un plan pentru a continua",
  afterSelectingPlanPersonalInfo:
    "După selectarea planului, vei putea completa informațiile tale personale",
  selectExamCategory:
    "Alege categoria de permis pentru care vrei să te pregătești!",
  selectExamCategoryToContinue:
    "Te rog selectează o categorie de examen pentru a continua",
  afterSelectingCategoryPersonalInfo:
    "După selectarea categoriei de examen, vei putea completa informațiile tale personale",
  noExamCategoriesAvailable:
    "Nu sunt categorii de examen disponibile în acest moment",
  selected: "Selectat",
  whatHappensNext: "Ce se întâmplă după?",
  registrationStep1Title: "Completează Date",
  registrationStep1Description:
    "Completează informațiile tale personale și de contact",
  registrationStep2Title: "Confirmare",
  registrationStep2Description:
    "Verifica datele și acceptă termenii de utilizare",
  registrationStep3Title: "Plată Inițială",
  registrationStep3Description:
    "Plătește prima lună a planului selectat pentru a activa contul",
  registrationStep4Title: "Acces Complet",
  registrationStep4Description:
    "Contul este creat instant și ai acces imediat la cursuri",
  operationCompletedSuccessfully: "Operațiunea a fost finalizată cu succes",
  credentialsEmailSent:
    "Datele de autentificare au fost trimise pe email. Vă puteți conecta utilizând aceste credențiale.",
  createAccount: "Crează Cont",

  // Purchase/Addon Feature
  purchaseAddons: "Efectuează o plată",
  purchaseAddonTitle: "Achiziții suplimentare",
  purchaseSupplementaryHours: "Cumpără ore suplimentare",
  hourPackage: "Pachet de ore",
  hoursPackage: "Pachet ore",
  addToCart: "Adaugă la coș",
  selectPackage: "Selectează pachet",
  selectedPackage: "Pachet selectat",
  packagePrice: "Preț pachet",
  pricePerHour: "Preț per oră",
  totalHours: "Total ore",
  hourPackages: "Pachete de ore",
  noHourPackagesAvailable: "Nu sunt pachete de ore disponibile",

  // Payment Amount Selector
  remainingAmountToPay: "Suma de plată rămasă",
  selectFixedAmount: "Selectați o valoare fixă",
  orText: "SAU",
  enterCustomAmount: "Introduceți valoarea dorită",
  selectedAmount: "Suma selectată",
  proceedToPayment: "Continuă la plată",
  pleaseSelectValidAmount: "Vă rugăm să selectați o sumă validă",
  amountExceedsRemainingBalance: "Suma nu poate depăși suma datorată",
  renewSubscriptionMonth: "Prelungește pentru o lună",
  monthlyRenewal: "Reînnoire lunară",
  subscriptionRenewalMonth: "Reînnoire abonament pentru o lună",
  purchaseHours: "Achiziție ore",
  buyNow: "Cumpără acum",
  selectQuantity: "Selectează cantitate",
  hoursPerPackage: "ore pe pachet",
  noSubscription: "Continuă pregătirea ta!",
  addNewProduct: "Adaugă un produs nou",
  addNewProductTitle: "Adaugă un produs nou la contul tău",
  selectServiceType: "Tipul serviciului",
  selectProduct: "Selectează produsul",
  noSubscriptionMessage:
    "Poți achita restul școlii sau adăuga ore suplimentare atunci când ai nevoie. Cumpără 5 ore deodată, obții 1 oră GRATUIT!",
  purchaseHoursDescription:
    "Achiziționează ore suplimentare pentru a continua pregătirea",
  purchaseProcessing: "Se procesează achiziția...",
  purchaseSuccess: "Achiziția a fost realizată cu succes!",
  purchaseError: "Eroare la realizarea achiziției!",
  selectAddonOption: "Selectează o opțiune",
  addonOption: "Opțiune suplimentară",
  confirmPurchase: "Confirmă achiziția",
  purchaseSummary: "Rezumat achiziție",
  purchaseConfirmation: "Confirmare achiziție",
  hourCount: "Numărul de ore",
  freeHoursPromotion: "Cumpără 5 ore deodată, obții 1 oră GRATUIT!",
  bonusHours: "Ore gratuite",
  totalWithBonusHours: "Total (cu ore gratuite)",
  freeHoursMessage: "Félicitări! Ai {freeHours} oră{plural} GRATUITĂ{plural}",

  // Subscription Expired Page
  subscriptionExpired: "Abonamentul a Expirat",
  subscriptionExpiredMessage:
    "Din păcate, abonamentul tău a expirat. Pentru a continua să beneficiezi de acces la cursuri și resursele noastre, te rugăm să reînnoiești abonamentul.",
  restoreAccess: "Restaurează Accesul",
  renewSubscription: "Prelungește abonamentul",
  renewNow: "Prelungește acum",
  upgradeSubscription: "Upgrade abonament",
  upgradeNow: "Upgrade acum",
  selectUpgradePlan: "Selectează planul de upgrade",
  selectRenewalPlan: "Selectează planul de reînnoire",
  selectButton: "Selectează plan",
  currentPlan: "Plan actual",
  processing: "Se procesează",
  subscriptionExpiredDetails:
    "După reînnoirea abonamentului, vei avea din nou acces la toate cursurile, modulele si informații.",
  contactSupportForHelp:
    "Ai nevoie de ajutor? Ne poți contacta pentru mai multe informații.",
  subscriptionSummary: "Rezumat Abonament",
  activePlan: "Abonament Activ",
  expirationDate: "Data Expirării",
  renewalPrice: "Preț Reînnoire",
  subscriptionRenewalSuccess:
    "Felicitări! Abonamentul tău a fost reînnoit cu succes!",
  subscriptionRenewalSuccessMessage:
    "Poți accesa din nou toate cursurile, modulele și informațiile. Mulțumim că ești alături de noi!",
  perMonth: "/ lună",
  benefitsAfterRenewal: "După reînnoire vei beneficia de:",
  courseAccess: "Acces la cursuri",
  allCoursesAndLessons: "Toate cursurile și lecțiile",
  drivingHours: "Ore de conducere",
  drivingLessonsBooking: "Programări pentru lecții practice",
  examsAccess: "Examene",
  examsAndSimulations: "Simulări și examene oficiale",
  supportAccess: "Suport",
  supportAndConsultancy: "Asistență și consultanță",
  courseCompletion: "Achită restul școlii",
  daysRemaining: "Zile rămase",
  paid: "Plătit",
  pay: "Plătește",
  paymentSuppliemntaryHoursSuccessMessage:
    "Orele suplimentare au fost adăugate în contul dumneavoastră.",
  buySupplementaryHours: "Cumpără ore suplimentare",
  upgradeAccount: "Actualizează-ți Contul",
  freeSubscriptionMessage:
    "Upgrade la o subscriere plătită pentru a accesa cursuri, examene și alte funcții premium.",
  paySchool: "Achită restul taxei școlare",
  amountCannotExceed: " Suma nu poate depăși",
  paymentRedirectWarning: "Veți fi redirecționat(ă) către terminalul de plată",
  schoolPaymentDescription: "Plată din aplicație",
  successfulRenewalMessage:
    "Reînnoirea a fost efectuată! Bucură-te în continuare de toate beneficiile abonamentului.",
  selectService: "Selectează serviciul",
  joinSession: "Intră în sesiune",
  refresh: "Actualizează",
  liveSessionError: "Eroare la încărcarea sesiunii live. Încearcă din nou.",
  videoCall: "Video Call",
  startVideoCall: "Începe video call",
  joinVideoCall: "Intră în video call",
  endVideoCall: "Închide video call",
  videoCallLoading: "Se conectează la video call...",
  videoCallError: "Eroare la conectarea la video call. Încearcă din nou.",
  videoCallEnded: "Video call-ul s-a încheiat.",
};
